import React, { forwardRef } from "react";
import {
  bool,
  func,
  instanceOf,
  node,
  oneOfType,
  shape,
  string
} from "prop-types";

import * as S from "./styled";

const ContactButtons = forwardRef(
  (
    {
      buttonRef,
      children,
      isVertical,
      primaryClick,
      primaryText,
      secondaryClick,
      secondaryText
    },
    ref
  ) => (
    <S.ButtonsContainer ref={ref} isVertical={isVertical}>
      {children}
      <S.PrimaryContactButton ref={buttonRef} onClick={primaryClick}>
        {primaryText}
      </S.PrimaryContactButton>
      <S.SecondaryContactButton onClick={secondaryClick}>
        {secondaryText}
      </S.SecondaryContactButton>
    </S.ButtonsContainer>
  )
);

ContactButtons.propTypes = {
  buttonRef: oneOfType([func, shape({ current: instanceOf(Element) })]),
  children: node,
  isVertical: bool.isRequired,
  primaryClick: func.isRequired,
  primaryText: string.isRequired,
  secondaryClick: func.isRequired,
  secondaryText: string.isRequired
};

ContactButtons.defaultProps = {
  buttonRef: null,
  children: null
};

export default ContactButtons;
